import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import qp from 'query-parse';

import config from 'config/index';

import { isElectron } from 'services/env-service';

import IconMicrosoft from 'icons/icon-microsoft';

const REDIRECT_URL = `${config.HOST}/auth/microsoft/callback`;
const MICROSOFT_AUTH_URL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`;

const MicrosoftLogin = ({ className = 'btn btn-secondary', disabled, acceptInviteToken, text, asNewWindow, children, t }) => {
    const handleClick = event => {
        if (disabled) {
            event.preventDefault();
        }
    }

    const state = useMemo(() => {
        const result = [];

        if (isElectron()) {
            result.push('isElectron=true');
        }

        if (acceptInviteToken) {
            result.push(`acceptInviteToken=${acceptInviteToken}`);
        }

        return result.join('|');
    }, [acceptInviteToken]);

    const sharedProps = useMemo(() => {
        const queryParams = qp.toString({
            response_type: 'code',
            scope: ['user.read.all', 'offline_access', 'openid', 'profile', 'email'].join(' '),
            client_id: config.MICROSOFT_CONFIG.CLIENT_ID,
            redirect_uri: REDIRECT_URL,
            state
        });

        const result = {
            href: `${MICROSOFT_AUTH_URL}?${queryParams}`,
            disabled
        };

        if (isElectron() || asNewWindow) {
            result.target = '_blank';
        }

        return result;
    }, [state, asNewWindow, disabled]);

    if (children) {
        return <a {...sharedProps} style={{display: 'inline-block', verticalAlign: 'top'}}>{ children }</a>;
    }

    return (
        <a {...sharedProps} className={className + (disabled ? ' disabled' : '')}>
            <IconMicrosoft />

            { text ?? t('Sign in with Microsoft') }
        </a>
    );
}

export default withTranslation('apps')(MicrosoftLogin);
